import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const getLocalesData = () => {
  const files = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const localeData = {
      datetimeFormats: {},
      numberFormats: {},
      messages: {}
  }
  const keys = files.keys();
  keys.forEach((key) => {
      // extract name without extension
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
          const localeId = matched[1]
          // from each file, set the related messages property
          localeData.datetimeFormats[localeId] = files(key).datetimeFormats
          localeData.numberFormats[localeId] = files(key).numberFormats
          localeData.messages[localeId] = files(key).messages
      }
  })
  return localeData

}

const data = getLocalesData()

const i18n = new VueI18n({
  locale: 'th-TH',
  fallbackLocale: 'th-TH',
  messages: data.messages,
  datetimeFormats: data.datetimeFormats,
  numberFormats: data.numberFormats
});

export default i18n; 